import useTimetableViewerPageElement from '../../../hooks/commonEvents/useTimetableViewerPageElement';

const TimetableViewerPage = (props) => useTimetableViewerPageElement(props);

export default TimetableViewerPage;
